import { Link, useLocation } from "react-router-dom";
import SiteHeader from "@/components/feature/SiteHeader";
import SiteFooter from "@/components/feature/SiteFooter";

const quickLinks = [
  { to: "/", label: "回首页", icon: "ri-home-4-line" },
  { to: "/category/entertainment", label: "娱乐圈", icon: "ri-vip-crown-line" },
  { to: "/category/influencer", label: "网红圈", icon: "ri-live-line" },
  { to: "/about", label: "关于我们", icon: "ri-user-heart-line" },
];

export default function NotFound() {
  const location = useLocation();

  return (
    <div className="flex flex-col min-h-screen bg-background-50">
      <SiteHeader />
      <main className="flex-1 flex items-center justify-center px-4 md:px-8 py-20">
        <div className="w-full max-w-2xl text-center">
          <span className="font-display text-7xl md:text-9xl text-primary-200 select-none">
            404
          </span>
          <h1 className="mt-4 text-2xl md:text-3xl font-bold text-foreground-950">
            这个页面好像没熟
          </h1>
          <p className="mt-3 text-sm md:text-base text-foreground-500">
            你访问的地址不存在或已下线，先回瓜田里看看今天的热瓜吧。
          </p>
          <p className="mt-2 text-xs text-foreground-400 font-mono break-all">
            {location.pathname}
          </p>

          <div className="mt-8 flex flex-wrap justify-center gap-3">
            {quickLinks.map((item) => (
              <Link
                key={item.to}
                to={item.to}
                className="inline-flex items-center gap-2 h-11 px-5 rounded-full bg-background-100 border border-background-200 text-sm text-foreground-700 whitespace-nowrap hover:border-primary-200 hover:text-primary-600 transition-colors cursor-pointer"
              >
                <i className={item.icon} aria-hidden="true"></i>
                {item.label}
              </Link>
            ))}
          </div>
        </div>
      </main>
      <SiteFooter />
    </div>
  );
}